import PromoCampaignHandlerCreate from './PromoCampaignHandlerCreate'

export default PromoCampaignHandlerCreate
